import { render, staticRenderFns } from "./AiReportingChatModal.vue?vue&type=template&id=267d484c&scoped=true&"
import script from "./AiReportingChatModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiReportingChatModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AiReportingChatModal.vue?vue&type=style&index=0&id=267d484c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267d484c",
  null
  
)

export default component.exports